import { useMutation } from 'react-query';
import { getMenuInfo, deleteMenu } from 'components/MenuMakeDeleteAll/services';

export const useDeleteMenu = () => {
  return useMutation({
    mutationFn: deleteMenu,
  });
};

export const useGetMenuInfo = () => {
  return useMutation({
    mutationFn: getMenuInfo,
  });
};
